import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { ProjectEstimateService } from '@app/cem/project/services/project-estimate.service';
import { Subscription } from 'rxjs';
import { ProjectScopingBrokerService } from '../../services/project-scoping-broker.service';
import { IScopingCapitalDataResponse, ProjectScopingService } from '../../services/project-scoping.service';

@Component({
  selector: 'app-project-scoping-capital',
  templateUrl: './project-scoping-capital.component.html',
  styleUrls: ['./project-scoping-capital.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ProjectScopingCapitalComponent implements OnInit, OnDestroy {
  private projectScopingService = inject(ProjectScopingService);
  private broker = inject(ProjectScopingBrokerService);
  private projectEstimateService = inject(ProjectEstimateService);
  private cdr = inject(ChangeDetectorRef);

  readonly projectId = input<number>(undefined);
  readonly scenarioId = input<number>(undefined);

  public estimateTotal: string;
  public costPerWell: string;
  public costPerLL: string;
  public costPerCum365BO: string;

  private saveChangesSuccessfulEventSub: Subscription;

  ngOnInit() {
    this.saveChangesSuccessfulEventSub = this.broker.SaveChangesSuccessfulEvent.subscribe(s => {
      if (s != null) this.handleSaveChangesEvent(s);
    });
  }

  ngOnDestroy() {
    if (this.saveChangesSuccessfulEventSub) {
      this.saveChangesSuccessfulEventSub.unsubscribe();
    }
  }

  private handleSaveChangesEvent(e: any) {
    if (!e) return;

    this.projectEstimateService.startEstimateEngine(this.projectId(), 3).then(() => {
      this.loadCapitalData();
    });
  }

  public async loadCapitalData() {
    await this.projectScopingService.getScopingCapitalData(this.projectId(), this.scenarioId()).then((capitalData: IScopingCapitalDataResponse) => {
      this.estimateTotal = this.USDConversion(capitalData.EstimateTotal);
      this.costPerWell = this.USDConversion(capitalData.CostPerWell);
      this.costPerLL = this.USDConversion(capitalData.CostPerLL);
      this.costPerCum365BO = this.USDConversion(capitalData.CostPerCum365BO);
      this.cdr.detectChanges();
    });
  }

  private USDConversion(input: number): string {
    return input.toLocaleString("en-US", { style: "currency", currency: "USD" });
  }
}